// Sync
import _ from 'lodash';

/* eslint-disable import/prefer-default-export */
import {
  SET_COLLECTED_GOODIES,
  SET_COLLECTED_NEW_GOODIES,
  SET_NEW_GOODY,
  PETS,
} from '../constants';

import getNewGoodyOfPetType from '../utils/getNewGoodyOfPetType';
import { setActiveGoodyAsync } from './activeGoodies';


// --- GET NEW GOODY --- //

function setNewGoody(id) {
  return {
    type: SET_NEW_GOODY,
    payload: {
      id,
    },
  };
}

// Get a goody for this specific type of pet.
export function getNewGoodyOnPurchase(petSku) {
  return (dispatch, getState) => {
    // Find this pet type.
    const petType = _.find(PETS, ['sku', petSku]).type;
    // Get a new goody for this pet type, if one exists.
    const newGoodyOfPetType = getNewGoodyOfPetType(getState().collectedGoodies.list, petType);

    // If there's a new goody for this pet type, save it and put it on the pet.
    if (newGoodyOfPetType) {
      // Add the new goody to the 'new' collection.
      dispatch(setNewGoody(newGoodyOfPetType.id));
      // Put the new goody on the pet.
      dispatch(setActiveGoodyAsync(
        newGoodyOfPetType.type,
        newGoodyOfPetType.id,
        { leaveShuffleAlone: true },
      ));
    }
  };
}

// --- COLLECTED GOODIES --- //

export function setCollectedGoodies(collectedGoodies) {
  return {
    type: SET_COLLECTED_GOODIES,
    payload: {
      collectedGoodies,
    },
  };
}


// --- NEW COLLECTED GOODIES --- //

function setCollectedNewGoodies(collectedNewGoodies) {
  return {
    type: SET_COLLECTED_NEW_GOODIES,
    payload: {
      collectedNewGoodies,
    },
  };
}

export function setCollectedNewGoodiesAsync(collectedNewGoodies) {
  return (dispatch, getState) => {
    // Only dispatch if they're not equal.
    if (!_.isEqual(getState().collectedGoodies.newItems, collectedNewGoodies)) {
      dispatch(setCollectedNewGoodies(collectedNewGoodies));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/collectedGoodies.js